import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';
import { apiHost, defectManagementConfig, DEFECTS_ACCESS_TOKEN } from '../utils/request';

const Admin = ({ userRights, profile }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    adminLinks: {
      manageAccount,
      manageControl,
      hardwareGridUpload,
      defectManagement,
      manageProducts
    }
  } = localizedStrings;

  // const userProfile = JSON.parse(localStorage.getItem('userProfile'));

  return (
    <>
      {userRights.isAdminBandVisible && (
        <>
          {userRights.isAdminBandVisible && (
            <li>
              <div >
              <Link variant="link" to="/manage-control/dealerships">
                  {manageControl}
                </Link>
              </div>
            </li>
          )}
          {userRights.isUserPageVisible && (
            <li>
              <div>
                <Link variant="link" to="/users" >
                  {manageAccount}
                </Link>
              </div>
            </li>
          )}
          {userRights.isProductCatalogVisible && (
            <li>
              <div style={{ marginRight: '15px' }}>
                <Link variant="link" to="/product-catalogue-dashboard" style={{borderRight:"none"}}>
                  {manageProducts}
                </Link>
              </div>
            </li>
          )}
        </>
      )
      }
    </>
  );
};

Admin.propTypes = {
  userRights: PropTypes.shape({
    isStatusEditable: PropTypes.bool,
    isUserEditable: PropTypes.bool,
    canAssignOrder: PropTypes.bool,
    isAdminBandVisible: PropTypes.bool,
    isUserPageVisible: PropTypes.bool,
    isSOVDashboardVisible: PropTypes.bool,
    isBulkUploadVisible: PropTypes.bool,
    isHardwareGridUploadVisible: PropTypes.bool,
    isProductCatalogVisible:PropTypes.bool
  }).isRequired
};

export default Admin;